import {useEffect, useRef} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import { useAtom } from "jotai/index";
import { profile} from "@/atoms/profile.ts";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import Factories from "@/utils/factories.ts";
import {useTranslation} from "react-i18next";
import useAuth from "@/hooks/auth.ts";


interface Props {
    applications: CreditApplicationInterface[]
}

const SignButKYCNotAllowedListener:React.FC<Props> =({applications}) => {
    const [user] = useAtom(profile)
    const interval = useRef<any>(null)
    const auth = useAuth()
    const {t} = useTranslation()
    const count_ref = useRef<number>(0)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const sign_with_kyc = (Array.isArray(applications) && applications.length) ? applications.find((x:CreditApplicationInterface) => Factories.application_status_simplification(x.status) === "sign_with_kyc") || undefined : undefined

    useEffect(() => {


        if(sign_with_kyc && !user?.permissions.is_kyc_allowed){
            interval.current = setInterval(async() => {
                count_ref.current += 1

                if(count_ref.current > 3) {
                    clearInterval(interval.current)
                    return
                }

                const updated = await auth.small_update()
                if(debug === "true") console.info("small_update 1")
                if(updated.permissions.is_kyc_allowed) {
                    eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "success", t("kyc_is_allowed"))
                    clearInterval(interval.current)
                }

            }, 10000)
        }
    }, [user, applications]);

    return null
}

export default SignButKYCNotAllowedListener